import React from 'react'
import PropTypes from 'prop-types'

import ContentHolder from '../../ui/ContentHolder'
import Agent from './Agent'
import styles from './styles.scss'

const renderAgents = (agents, campaign) => {
  if (campaign.agents){
    return campaign.agents.map((agentId) => {
      const agent = agents[agentId] || {}
      return (
        <Agent key={agent.id} agent={agent} campaign={campaign} />
      )
    })
  }

  return null
}

const Footer = (props) => {
  const { agents, campaign } = props

  return (
    <div className={styles.root}>
      <ContentHolder>
        <h1>Thank You</h1>

        <p className={styles.intro}>
          Thank you for giving us the opportunity to provide you with the information to make an informed decision. If
          you&apos;ve got any further questions, or would like to book in a meeting, please contact us.
        </p>

        <div className={styles.agents}>
          {renderAgents(agents, campaign)}
        </div>
      </ContentHolder>
    </div>
  )
}

Footer.propTypes = {
  agents: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
}

export default Footer
